import { useMemo } from "react";
import { isInProgress } from "../utils/job-status.utils";
import { useJobDataManager } from "./useJobDataManager";

export const useJobCounter = (): number => {
  const { pushedJobs } = useJobDataManager();

  const count: number = useMemo((): number => {
    const pushedJobInProgressQuantity = Array.from(pushedJobs.values()).filter(
      (pushedJob) => isInProgress(pushedJob),
    )?.length;

    return pushedJobInProgressQuantity;
  }, [pushedJobs]);

  return count ?? 0;
};
